<template>
	<div style="overflow-x: hidden;">
		<el-menu :default-active="activeIndex" class="el-menu" mode="horizontal" @select="handleSelect">
			<el-menu-item index="1">设备概况</el-menu-item>
			<el-menu-item index="2" v-if="codeDic['page_history']">历史记录</el-menu-item>
			<el-menu-item index="3" v-if="codeDic['page_alarm']">报警记录</el-menu-item>
			<el-menu-item index="4" v-if="codeDic['page_analysis']">分析记录</el-menu-item>
			<el-menu-item index="8" v-if="codeDic['page_chemistry_statistics']">化学品消耗统计</el-menu-item>
			<el-menu-item index="5" v-if="codeDic['page_maintenance']">维护工单</el-menu-item>
			<el-menu-item index="6" v-if="codeDic['page_maintenance_help']">维护求助</el-menu-item>
			<el-menu-item index="7" v-if="codeDic['page_system_detail']">系统概况</el-menu-item>
			<el-menu-item index="9" v-if="codeDic['page_operation_log']">运营记录</el-menu-item>
		</el-menu>
		<el-row class="contents">
			<component ref="component" :is="currentComponent" :templateId="templateId" :deviceId="deviceId"
			 :device="device" v-if="activeIndex" :variableId="variableId" :variableTitle="variableTitle"  @goHistory="goHistory" ></component>
		</el-row>

	</div>
</template>

<script>
	import templateVariableValueLog from '../log/templateVariableValueLog.vue';
	import alarmLog from '../log/alarmLog.vue';
	import analysisLog from '../log/analysisLog.vue';
	import maintenanceHelpOrder from '../order/maintenanceHelpOrder.vue';
	import maintenanceOrder from '../order/maintenanceOrder.vue';
	import deviceInfo from '../device/deviceInfo.vue';
	import chemicalsDeviceStatistics from '@/view/system/chemicalsDeviceStatistics';
	import standard from '@/view/system/standard';
	import operationLog from '../device/operationLog.vue';
	

	export default {
		components: {
			templateVariableValueLog,
			alarmLog,
			analysisLog,
			maintenanceHelpOrder,
			maintenanceOrder,
			deviceInfo,
			chemicalsDeviceStatistics,
			standard
		},
		data() {
			return {
				activeIndex: null,
				currentComponent: null,
				deviceId: 0,
				templateId: 0,
				device: {},
				menuTree: [],
				codeDic: {},
				variableId:null,
				variableTitle:null
			};
		},
		filters: {},
		methods: {
			handleSelect(key, keyPath) {
				this.variableId = null
				this.variableTitle = null
				this.deviceId = this.device.id
				this.$nextTick(() => {
					if (key === "1") {
						this.setPermTypes('page_device_detail')
						this.currentComponent = deviceInfo;
					} else if (key === "2") {
						this.setPermTypes('page_history')
						this.currentComponent = templateVariableValueLog;
					} else if (key === "3") {
						this.setPermTypes('page_alarm')
						this.currentComponent = alarmLog;
					} else if (key === "4") {
						this.setPermTypes('page_analysis')
						this.currentComponent = analysisLog;
					} else if (key === "5") {
						this.setPermTypes('page_maintenance')
						this.currentComponent = maintenanceOrder;
					} else if (key === "6") {
						this.setPermTypes('page_maintenance_help')
						this.currentComponent = maintenanceHelpOrder;
					} else if (key === "7") {
						this.setPermTypes('page_standard')
						this.currentComponent = standard;
					}else if (key === "8") {
						this.setPermTypes('page_chemistry_statistics')
						this.currentComponent = chemicalsDeviceStatistics;
					}else if (key === "9") {
						this.setPermTypes('page_operation_log')
						this.currentComponent = operationLog;
					}
					
				});
				console.log(key, keyPath);
			},
			goHistory(params){
				this.variableId= params.variableId;
				this.variableTitle= params.variableTitle;
				this.activeIndex = "2"
				this.currentComponent = templateVariableValueLog;
			},
			getDevice() {
				this.$http({
					method: 'GET',
					url: 'devices/detail?id=' + this.deviceId,
					data: {},
				}).then((res)=> {
					this.setPermTypes('page_device_detail')
					this.device = res.data.data;
					this.templateId = res.data.data.templateId;
					this.activeIndex = "1"
					this.currentComponent = deviceInfo
					this.$forceUpdate();
					
				})
			},
			setPermTypes(page){
				var data = this.codeDic[page];
				if(data&&data.permTypes){
					sessionStorage.setItem('displayButtonList', data.permTypes);
				}else{
					sessionStorage.setItem('displayButtonList', []);
				}
			},
			getMenu() { //获取菜单列表
				this.$http({
					method: 'POST',
					url: 'menus/tree',
					data: {},
				}).then((res) => {
					if (res.data.errorCode == '0000') {
						this.menuTree = res.data.data
						this.initSelect(res.data.data)
						this.getDevice(); 
						console.log(this.codeDic)
						console.log(this.codeDic["page_device_detail"])
					}
				})
			},
			initSelect(list) {
				if (list) {
					list.forEach(item => {
						if (item.code) {
							this.codeDic[item.code] = item;
						}
						this.initSelect(item.children)
						this.initSelect(item.hiddenChildren)
					})
				}
			}
		},
		mounted: function() {
			if (this.$route.query.deviceId) {
				this.deviceId = this.$route.query.deviceId;
				this.getMenu();
			}
		}
	};
</script>

<style scoped>
	.el-menu {
		padding-left: 20px;
	}

	/deep/ .el-menu .is-active {
		background: transparent !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/deviceDetail.vue